import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { forkJoin, Subscription } from 'rxjs';
import { DataStorageService } from 'src/app/shared/servizi/data-storage.service';
import { DbClicService } from 'src/app/shared/servizi/posizioni/posizioni_db-clic.service';
import { SpinnerService } from '../servizi/spinner/spinner.service';

@Component({
  selector: 'app-ctxmenu',
  templateUrl: './ctxmenu.component.html',
  styleUrls: ['./ctxmenu.component.css']
})
export class CtxmenuComponent implements OnInit {
  @Input() ctxMenu; //variabile context menu
  @Input() cy: any;
  @Input() relationType;
  @Output() nodiSelezionati = new EventEmitter<[]>();
  @Output() contextMenu = new EventEmitter; //variabile context menu
  @Input() focusNode: string;
  @Input() arrayNodi: any[];
  @Input() arrayEdge: any[];
  arrayIponimia;
  // emetto valore array iponimia
  @Output() arrayIpo = new EventEmitter<[]>();
  arrayMeronimia: any[];
  arraySinonimia: any[];
  arrayTutteRelazioni: any[];
  // STATO IPONIMIA
  @Input() statoNodiIpo: [] = [];
  @Input() statoEdgeIpo: any[];
  // STATO MERONIMIA
  @Input() statoNodiMero: [] = [];
  @Input() statoEdgeMero: any[];
  // STATO SINONIMIA
  @Input() statoNodiSino: [] = [];
  @Input() statoEdgeSino: any[];
  // STATO TUTTE RELAZIONI
  @Input() statoTutteRelazioni: [];

  @Input() formCercaSenso = new FormGroup({
    cercaUnSenso: new FormControl()
  });

  // invio valori array relazioni
  @Output() invioArrayIponimia = new EventEmitter<any[]>();
  @Output() invioArrayMeronimia = new EventEmitter<any[]>();
  @Output() invioArraySinonimia = new EventEmitter<any[]>();
  @Output() invioArrayTutteRelazioni = new EventEmitter<any[]>();
  // invio stato relazioni
  @Output() invioStatoIpo = new EventEmitter<[]>();
  @Output() invioStatoMero = new EventEmitter<[]>();
  @Output() invioStatoSino = new EventEmitter<[]>();

  // emetto valori per form distanza
  // iponimia
  @Output() valoreFormIpo = new EventEmitter<number>();
  // iperonimia
  @Output() valoreFormIpe = new EventEmitter<number>();
  // meronimia
  @Output() valoreFormMero = new EventEmitter<number>();
  // olonimia
  @Output() valoreFormOlo = new EventEmitter<number>();
  // valore tutte relazioni
  @Output() valoreFormTutteRelazioni = new EventEmitter<number>();

  // evento per disabilitare form distanza relazione iponimia
  @Output() disabilitoIpo = new EventEmitter<boolean>();
  @Output() disabilitoIpe = new EventEmitter<boolean>();
  // evento per disabilitare form distanza relazione meronimia
  @Output() disabilitoMero = new EventEmitter<boolean>();
  @Output() disabilitoOlo = new EventEmitter<boolean>();

  layoutSinonimi;
  sub1: Subscription;
  constructor(
    private dataStorageService: DataStorageService,
    private dbClic: DbClicService,
    private spinner: SpinnerService
  ) { }

  ngOnInit(): void {

    const that = this; //toglie errore undefined 
    let edgesInferred: boolean[];
    this.ctxMenu = {
      evtType: 'cxttap',
      menuItems: [
        {
          id: 'apriNodiEntranti',
          content: 'show incoming nodes',
          tooltipText: 'show incoming nodes',
          selector: 'node',
          onClickFunction: function (event) {
            that.spinner.showSpinner();
            // recupero nodi con session storage, prima del clic con il ctx menu
            sessionStorage.setItem('focusNode', event.target.data().id);
            let nodoDBClick = event.target;
            let elementoFocus = that.cy.getElementById(sessionStorage.getItem('focusNode'));
            that.arrayNodi = [];
            that.arrayEdge = [];
            that.arrayIponimia = [];
            that.arrayMeronimia = [];
            that.arraySinonimia = [];

            that.statoNodiIpo = JSON.parse(sessionStorage.getItem("statoNodiIpo"));
            that.statoEdgeIpo = JSON.parse(sessionStorage.getItem("statoEdgeIpo"));

            that.statoNodiMero = JSON.parse(sessionStorage.getItem("statoNodiMero"));
            that.statoEdgeMero = JSON.parse(sessionStorage.getItem("statoEdgeMero"));

            that.statoNodiSino = JSON.parse(sessionStorage.getItem("statoNodiSino"));
            that.statoEdgeSino = JSON.parse(sessionStorage.getItem("statoEdgeSino"));
            that.sub1 = that.dataStorageService.fetchSubGraph(sessionStorage.getItem('focusNode'), that.relationType, 1, "incoming").subscribe(subGraph => {
              if (subGraph) {
                that.spinner.hideSpinner();
              }
              let nodi: any = subGraph.nodes;
              let edges: any = subGraph.edges;

              if (nodi.length === 0) {
                if (that.relationType === 'hyponym') {
                  that.valoreFormIpo.emit(0);
                  that.disabilitoIpo.emit(true);
                }
                if (that.relationType === 'partMeronym') {
                  that.valoreFormMero.emit(0);
                  that.disabilitoMero.emit(true);
                }
              }
              if (nodi.length >= 1) {
                if (that.relationType === 'hyponym') {
                  that.valoreFormIpo.emit(1);
                  that.disabilitoIpo.emit(false);
                }
                if (that.relationType === 'partMeronym') {
                  that.valoreFormMero.emit(1);
                  that.disabilitoMero.emit(false);
                }
              }
              edgesInferred = subGraph.edges.map(ele => {
                return ele.data.inferred
              });
              if (nodi.length > 1000) {
                alert('attenzioni nodi > 1000, il caricamento dei sensi viene fermato')
                that.spinner.hideSpinner();
                // resetto valore a 0 
                // this.valoreFormIpom.emit(0);
                // nodi < 1000
              } else {
                for (var i = 0; i < nodi.length; i++) {
                  // aggiungo nodi
                  that.cy.add([{
                    group: "nodes",
                    data: {
                      id: subGraph.nodes[i].data.id,
                      label: subGraph.nodes[i].data.label
                    }
                  }]);
                  // aggiungo nodi ad array nodi
                  that.arrayNodi.length = that.arrayNodi.push(subGraph.nodes[i].data.id);
                  // salvo gli elementi negli array delle relazioni
                  // alla selezione di un radio button della relazione,
                  // rimuovo elementi delle relazioni che non mi interessano, così rimuovo lo spazio occupato dai nodi nascosti
                  if (that.relationType === 'hyponym') {
                    that.arrayIponimia.length = that.arrayIponimia.push(subGraph.nodes[i].data.id);
                    that.invioArrayIponimia.emit(that.arrayIponimia);
                    sessionStorage.setItem("statoNodiIpo", JSON.stringify(that.arrayIponimia.length));
                    that.invioStatoIpo.emit(that.statoNodiIpo);
                    that.valoreFormIpo.emit(1);
                  }
                  if (that.relationType === 'partMeronym') {
                    that.arrayMeronimia.length = that.arrayMeronimia.push(subGraph.nodes[i].data.id);
                    that.invioArrayMeronimia.emit(that.arrayMeronimia);
                    sessionStorage.setItem("statoNodiMero", JSON.stringify(that.arrayMeronimia.length));
                    that.invioStatoMero.emit(that.statoNodiMero);
                    that.valoreFormMero.emit(1);
                  }
                  if (that.relationType === 'synonym') {
                    that.arraySinonimia.length = that.arraySinonimia.push(subGraph.nodes[i].data.id);
                    that.invioArraySinonimia.emit(that.arraySinonimia);
                    sessionStorage.setItem("statoNodiSino", JSON.stringify(that.arraySinonimia.length));
                    that.invioStatoSino.emit(that.statoNodiSino);
                  }
                  // nascondo nodi secondo livello
                  // nodoDBClick.outgoers().targets().successors().style('display', 'none');
                  // nodoDBClick.incomers().sources().predecessors().style('display', 'none');
                  // nascondo nodi secondo livello
                  nodoDBClick.outgoers().targets().successors().targets().style('display', 'none');
                  nodoDBClick.outgoers().targets().incomers().sources().style('display', 'none');
                  nodoDBClick.incomers().sources().incomers().sources().style('display', 'none');
                  let uguali = nodoDBClick.outgoers().targets().incomers().sources().find(el => {
                    if (el.data().id === subGraph.nodes[i].data.id) {
                      that.cy.add([{
                        group: "nodes",
                        data: {
                          id: subGraph.nodes[i].data.id,
                          label: subGraph.nodes[i].data.label
                        }
                      }]);
                      return subGraph.nodes[i].data.id
                    }
                  });
                  that.cy.getElementById(subGraph.nodes[i].data.id).style('display', 'element');
                  that.cy.getElementById(subGraph.nodes[i].data.id).addClass("label");
                }
                for (var i = 0; i < edges.length; i++) {
                  // aggiungo edge
                  that.cy.add([{
                    group: "edges",
                    data: {
                      id: subGraph.edges[i].data.id,
                      source: subGraph.edges[i].data.source,
                      target: subGraph.edges[i].data.target
                    }
                  }]);
                  // aggiungo edge ad array di edges
                  that.arrayEdge.length = that.arrayEdge.push(that.cy.getElementById(subGraph.edges[i].data.id));
                  that.cy.getElementById(subGraph.edges[i].data.id).style('display', 'element');
                  that.cy.getElementById(subGraph.edges[i].data.id).addClass('edges');
                  if (that.relationType === 'hyponym') {
                    sessionStorage.setItem("statoEdgeIpo", JSON.stringify(that.arrayEdge.length));
                  }
                  if (that.relationType === 'partMeronym') {
                    sessionStorage.setItem("statoEdgeMero", JSON.stringify(that.arrayEdge.length));
                  }
                  if (that.relationType === 'synonym') {
                    sessionStorage.setItem("statoEdgeSino", JSON.stringify(that.arrayEdge.length));
                  }
                  that.cy.batch(function () {
                    nodoDBClick
                      .removeClass('grigio')
                      .removeClass('2livello')
                      .addClass('1livello')
                      .style('display', 'element')
                      ;
                  });

                  let nodiConnessi = that.cy.getElementById(edges[i].data.id).connectedNodes();

                  if (edges[i].data.relationType === 'hyponym') {
                    nodoDBClick.outgoers().targets().removeClass('iponimiaDBClick');
                    that.cy.batch(function () {
                      nodiConnessi
                        .removeClass('2livello')
                        .removeClass('meronimia')
                        .removeClass('sinonimia')
                        .removeClass('iponimiaDBClick')
                        .addClass('iponimia')
                        ;
                    });
                    that.cy.getElementById(edges[i].data.id).sources().removeClass('grigio');
                    nodoDBClick.addClass('iponimiaDBClick');
                  }
                  if (edges[i].data.relationType === 'partMeronym') {
                    nodoDBClick.outgoers().targets().removeClass('meronimiaDBClick');
                    that.cy.batch(function () {
                      nodiConnessi
                        .removeClass('2livello')
                        .removeClass('iponimia')
                        .removeClass('sinonimia')
                        .removeClass('meronimiaDBClick')
                        .addClass('1livello')
                        .addClass('meronimia')
                        ;
                    });
                    that.cy.getElementById(edges[i].data.id).sources().removeClass('grigio');
                    nodoDBClick.addClass('meronimiaDBClick');
                  }
                  // nodi inferiti visibili SOLO nella relazione di sinonimia
                  if (edges[i].data.relationType === 'synonym') {
                    that.cy.batch(function () {
                      nodiConnessi
                        .removeClass('2livello')
                        .removeClass('meronimia')
                        .removeClass('iponimia')
                        .removeClass('sinonimiaDBClick')
                        .addClass('sinonimia')
                        ;
                    });
                    that.cy.getElementById(edges[i].data.id).sources().removeClass('grigio');
                    nodoDBClick.addClass('sinonimiaDBClick');

                    if (edgesInferred[i] === true) {
                      that.cy.getElementById(subGraph.edges[i].data.id).addClass("inferred");
                    } else {
                      that.cy.getElementById(subGraph.edges[i].data.id).removeClass("inferred");
                      elementoFocus.successors().removeClass("edges");
                      elementoFocus.successors().targets().incomers().removeClass("edges");
                      that.cy.getElementById(subGraph.edges[i].data.id).addClass("edges");
                    }
                  }

                  // edge > 499
                  if (edges.length > 499) {
                    let nodiGrigi = that.cy.getElementById(edges[i].data.id).connectedNodes();
                    let edgeGrigi = that.cy.getElementById(edges[i].data.id);
                    //  RIMUOVO TUTTE LE CLASSI DI STILE
                    that.cy.batch(function () {
                      nodiGrigi
                        .removeClass('meronimia')
                        .removeClass('sinonimia')
                        .removeClass('meronimiaDBClick')
                        .removeClass('sinonimiaDBClick')
                        .removeClass('iponimia')
                        .removeClass('iponimiaDBClick')
                        .removeClass('label')
                        .addClass('bigGraph')
                        ;
                    });
                    that.cy.batch(function () {
                      edgeGrigi
                        .removeClass('edges')
                        ;
                    });
                    if (edges[i].data.relationType === 'hyponym') {
                      nodoDBClick.addClass('iponimiaDBClick');
                    }
                    if (edges[i].data.relationType === 'partMeronym') {
                      nodoDBClick.addClass('meronimiaDBClick');
                    }
                    if (edges[i].data.relationType === 'synonym') {
                      nodoDBClick.addClass('sinonimiaDBClick');
                    }
                    nodoDBClick.style('z-index', '1')
                  }
                }
                if (that.relationType === 'hyponym' || that.relationType === 'partMeronym') {
                  that.dbClic.posizioni(event);
                  if (nodoDBClick.connectedEdges().toArray().length > 20 && nodoDBClick.connectedEdges().toArray().length < 200) {
                    that.cy.fit();
                  } else if (nodoDBClick.connectedEdges().toArray().length > 200 || nodoDBClick.connectedEdges().toArray().length > 200) {
                    that.cy.fit();
                  } else {
                    that.cy.zoom({
                      level: 1.0, // the zoom level
                    });
                    that.cy.center();
                  }
                  if (that.isGraphOutOfView() === true) {
                    that.cy.fit();
                  }
                }
                if (that.relationType === 'synonym') {
                  that.layoutSinonimi = nodoDBClick.incomers().sources().layout({
                    name: 'circle',
                    padding: 200,
                    avoidOverlap: true,
                    radius: 10,
                    startAngle: 3 / 2 * Math.PI,
                    sweep: undefined,
                    clockwise: true,
                  });
                  that.layoutSinonimi.run();
                }
              }
            })
          },
          disabled: false
        },
        {
          id: 'apriNodiUscenti',
          content: 'show outgoing nodes',
          tooltipText: 'show outgoing nodes',
          selector: 'node',
          onClickFunction: function (event) {
            // that.ctxMenuOpen = true;
            that.spinner.showSpinner();
            // recupero nodi con session storage, prima del clic con il ctx menu
            sessionStorage.setItem('focusNode', event.target.data().id);
            let nodoDBClick = event.target;
            let elementoFocus = that.cy.getElementById(sessionStorage.getItem('focusNode'));
            that.arrayNodi = [];
            that.arrayEdge = [];
            that.arrayIponimia = [];
            that.arrayMeronimia = [];
            that.arraySinonimia = [];

            that.statoNodiIpo = JSON.parse(sessionStorage.getItem("statoNodiIpo"));
            that.statoEdgeIpo = JSON.parse(sessionStorage.getItem("statoEdgeIpo"));

            that.statoNodiMero = JSON.parse(sessionStorage.getItem("statoNodiMero"));
            that.statoEdgeMero = JSON.parse(sessionStorage.getItem("statoEdgeMero"));

            that.statoNodiSino = JSON.parse(sessionStorage.getItem("statoNodiSino"));
            that.statoEdgeSino = JSON.parse(sessionStorage.getItem("statoEdgeSino"));
            that.sub1 = that.dataStorageService.fetchSubGraph(sessionStorage.getItem('focusNode'), that.relationType, 1, "outgoing").subscribe(subGraph => {
              if (subGraph) {
                that.spinner.hideSpinner();
              }
              let nodi: any = subGraph.nodes;
              let edges: any = subGraph.edges;
              if (nodi.length === 0) {
                if (that.relationType === 'hyponym') {
                  that.valoreFormIpe.emit(0);
                  that.disabilitoIpe.emit(true);
                }
                if (that.relationType === 'partMeronym') {
                  that.valoreFormOlo.emit(0);
                  that.disabilitoOlo.emit(true);
                }
              }
              if (nodi.length >= 1) {
                if (that.relationType === 'hyponym') {
                  that.valoreFormIpe.emit(1);
                  that.disabilitoIpe.emit(false);
                }
                if (that.relationType === 'partMeronym') {
                  that.valoreFormOlo.emit(1);
                  that.disabilitoOlo.emit(false);
                }
              }

              edgesInferred = subGraph.edges.map(ele => {
                return ele.data.inferred
              });
              if (nodi.length > 1000) {
                alert('attenzioni nodi > 1000, il caricamento dei sensi viene fermato')
                that.spinner.hideSpinner();
                // resetto valore a 0 
                // this.valoreFormIpom.emit(0);
                // nodi < 1000
              } else {
                for (var i = 0; i < nodi.length; i++) {
                  // aggiungo nodi
                  that.cy.add([{
                    group: "nodes",
                    data: {
                      id: subGraph.nodes[i].data.id,
                      label: subGraph.nodes[i].data.label
                    }
                  }]);
                  // aggiungo nodi ad array nodi
                  that.arrayNodi.length = that.arrayNodi.push(subGraph.nodes[i].data.id);

                  // salvo gli elementi negli array delle relazioni
                  // alla selezione di un radio button della relazione,
                  // rimuovo elementi delle relazioni che non mi interessano, così rimuovo lo spazio occupato dai nodi nascosti
                  if (that.relationType === 'hyponym') {
                    that.arrayIponimia.length = that.arrayIponimia.push(subGraph.nodes[i].data.id);
                    that.invioArrayIponimia.emit(that.arrayIponimia);
                    sessionStorage.setItem("statoNodiIpo", JSON.stringify(that.arrayIponimia.length));
                    that.invioStatoIpo.emit(that.statoNodiIpo);
                    that.valoreFormIpe.emit(1);
                  }
                  if (that.relationType === 'partMeronym') {
                    that.arrayMeronimia.length = that.arrayMeronimia.push(subGraph.nodes[i].data.id);
                    that.invioArrayMeronimia.emit(that.arrayMeronimia);
                    sessionStorage.setItem("statoNodiMero", JSON.stringify(that.arrayMeronimia.length));
                    that.invioStatoMero.emit(that.statoNodiMero);
                    that.valoreFormOlo.emit(1);
                  }
                  if (that.relationType === 'synonym') {
                    that.arraySinonimia.length = that.arraySinonimia.push(subGraph.nodes[i].data.id);
                    that.invioArraySinonimia.emit(that.arraySinonimia);
                    sessionStorage.setItem("statoNodiSino", JSON.stringify(that.arraySinonimia.length));
                    that.invioStatoSino.emit(that.statoNodiSino);
                  }
                  // nascondo nodi secondo livello
                  // nodoDBClick.outgoers().targets().successors().style('display', 'none');
                  // nodoDBClick.incomers().sources().predecessors().style('display', 'none');
                  // nascondo nodi secondo livello
                  nodoDBClick.outgoers().targets().successors().targets().style('display', 'none');
                  nodoDBClick.outgoers().targets().incomers().sources().style('display', 'none');
                  nodoDBClick.incomers().sources().predecessors().style('display', 'none');

                  that.cy.getElementById(subGraph.nodes[i].data.id).style('display', 'element');
                  that.cy.getElementById(subGraph.nodes[i].data.id).addClass("label");
                }
                for (var i = 0; i < edges.length; i++) {
                  // aggiungo edge
                  that.cy.add([{
                    group: "edges",
                    data: {
                      id: subGraph.edges[i].data.id,
                      source: subGraph.edges[i].data.source,
                      target: subGraph.edges[i].data.target
                    }
                  }]);
                  // aggiungo edge ad array di edges
                  that.arrayEdge.length = that.arrayEdge.push(that.cy.getElementById(subGraph.edges[i].data.id));
                  that.cy.getElementById(subGraph.edges[i].data.id).style('display', 'element');
                  that.cy.getElementById(subGraph.edges[i].data.id).addClass('edges');

                  if (that.relationType === 'hyponym') {
                    sessionStorage.setItem("statoEdgeIpo", JSON.stringify(that.arrayEdge.length));
                  }
                  if (that.relationType === 'partMeronym') {
                    sessionStorage.setItem("statoEdgeMero", JSON.stringify(that.arrayEdge.length));
                  }
                  if (that.relationType === 'synonym') {
                    sessionStorage.setItem("statoEdgeSino", JSON.stringify(that.arrayEdge.length));
                  }

                  that.cy.batch(function () {
                    nodoDBClick
                      .removeClass('grigio')
                      .removeClass('2livello')
                      .addClass('1livello')
                      .style('display', 'element')
                      ;
                  });

                  let nodiConnessi = that.cy.getElementById(edges[i].data.id).connectedNodes();
                  if (edges[i].data.relationType === 'hyponym') {
                    that.cy.batch(function () {
                      nodiConnessi
                        .removeClass('2livello')
                        .removeClass('meronimia')
                        .removeClass('sinonimia')
                        .removeClass('iponimiaDBClick')
                        .addClass('iponimia')
                        ;
                    });
                    that.cy.getElementById(edges[i].data.id).targets().removeClass('grigio');
                    nodoDBClick.addClass('iponimiaDBClick');
                  }
                  if (edges[i].data.relationType === 'partMeronym') {
                    that.cy.batch(function () {
                      nodiConnessi
                        .removeClass('2livello')
                        .removeClass('iponimia')
                        .removeClass('sinonimia')
                        .removeClass('meronimiaDBClick')
                        .addClass('meronimia')
                        ;
                    });
                    that.cy.getElementById(edges[i].data.id).targets().removeClass('grigio');
                    nodoDBClick.addClass('meronimiaDBClick');
                  }
                  // nodi inferiti visibili SOLO nella relazione di sinonimia
                  if (edges[i].data.relationType === 'synonym') {
                    that.cy.batch(function () {
                      nodiConnessi
                        .removeClass('2livello')
                        .removeClass('meronimia')
                        .removeClass('iponimia')
                        .removeClass('sinonimiaDBClick')
                        .addClass('sinonimia')
                        ;
                    });
                    that.cy.getElementById(edges[i].data.id).targets().removeClass('grigio');
                    nodoDBClick.addClass('sinonimiaDBClick');

                    if (edgesInferred[i] === true) {
                      that.cy.getElementById(subGraph.edges[i].data.id).addClass("inferred");
                    } else {
                      that.cy.getElementById(subGraph.edges[i].data.id).removeClass("inferred");
                      elementoFocus.predecessors().removeClass("edges");
                      that.cy.getElementById(subGraph.edges[i].data.id).addClass("edges");
                    }
                  }
                  // edge > 499
                  if (edges.length > 499) {
                    let nodiGrigi = that.cy.getElementById(edges[i].data.id).connectedNodes();
                    let edgeGrigi = that.cy.getElementById(edges[i].data.id);
                    //  RIMUOVO TUTTE LE CLASSI DI STILE
                    that.cy.batch(function () {
                      nodiGrigi
                        .removeClass('meronimia')
                        .removeClass('sinonimia')
                        .removeClass('meronimiaDBClick')
                        .removeClass('sinonimiaDBClick')
                        .removeClass('iponimia')
                        .removeClass('iponimiaDBClick')
                        .removeClass('label')
                        .addClass('bigGraph')
                        ;
                    });
                    that.cy.batch(function () {
                      edgeGrigi
                        .removeClass('edges')
                        ;
                    });
                    if (edges[i].data.relationType === 'hyponym') {
                      nodoDBClick.addClass('iponimiaDBClick');
                    }
                    if (edges[i].data.relationType === 'partMeronym') {
                      nodoDBClick.addClass('meronimiaDBClick');
                    }
                    if (edges[i].data.relationType === 'synonym') {
                      nodoDBClick.addClass('sinonimiaDBClick');
                    }
                    nodoDBClick.style('z-index', '1')
                  }
                }
                if (that.relationType === 'hyponym' || that.relationType === 'partMeronym') {
                  that.dbClic.posizioni(event);
                  if (nodoDBClick.connectedEdges().toArray().length > 20 && nodoDBClick.connectedEdges().toArray().length < 200) {
                    that.cy.fit();
                  } else if (nodoDBClick.connectedEdges().toArray().length > 200 || nodoDBClick.connectedEdges().toArray().length > 200) {
                    that.cy.fit();
                  } else {
                    that.cy.zoom({
                      level: 1.0,
                    });
                    that.cy.center();
                  }
                  if (that.isGraphOutOfView() === true) {
                    that.cy.fit();
                  }
                }
                if (that.relationType === 'synonym') {
                  that.layoutSinonimi = nodoDBClick.outgoers().targets().layout({
                    name: 'circle',
                    padding: 200,
                    avoidOverlap: true,
                    radius: 10,
                    startAngle: 3 / 2 * Math.PI,
                    sweep: undefined,
                    clockwise: true,
                  });
                  that.layoutSinonimi.run();
                }
              }
            })
          },
          disabled: false
        },
        {
          id: 'apriTuttiNodi',
          content: 'show nodes',
          tooltipText: 'show nodes',
          selector: 'node',
          onClickFunction: function (event) {
            that.spinner.showSpinner();
            // recupero nodi con session storage, prima del clic con il ctx menu
            sessionStorage.setItem('focusNode', event.target.data().id);
            let nodoDBClick = event.target;
            let elementoFocus = that.cy.getElementById(sessionStorage.getItem('focusNode'));
            that.arrayNodi = [];
            that.arrayEdge = [];
            that.arrayIponimia = [];
            that.arrayMeronimia = [];
            that.arraySinonimia = [];
            that.statoNodiIpo = JSON.parse(sessionStorage.getItem("statoNodiIpo"));
            that.statoEdgeIpo = JSON.parse(sessionStorage.getItem("statoEdgeIpo"));

            that.statoNodiMero = JSON.parse(sessionStorage.getItem("statoNodiMero"));
            that.statoEdgeMero = JSON.parse(sessionStorage.getItem("statoEdgeMero"));

            that.statoNodiSino = JSON.parse(sessionStorage.getItem("statoNodiSino"));
            that.statoEdgeSino = JSON.parse(sessionStorage.getItem("statoEdgeSino"));
            // chiamate multiple
            let serverData1 = that.dataStorageService.fetchSubGraph(sessionStorage.getItem('focusNode'), that.relationType, 1, "incoming")
            let serverData2 = that.dataStorageService.fetchSubGraph(sessionStorage.getItem('focusNode'), that.relationType, 1, "outgoing")
            const arr = [serverData1, serverData2]
            let multiCall = forkJoin(arr)
            that.sub1 = multiCall.subscribe(subGraph => {
              if (subGraph) {
                that.spinner.hideSpinner();
              }
              let incoming: any = subGraph[0].edges;
              let outgoing: any = subGraph[1].edges;
              // disabilito form distanza se non ci sono nodi con lunghezza
              if (incoming.length === 0) {
                if (that.relationType === 'hyponym') {
                  that.valoreFormIpo.emit(0);
                  that.disabilitoIpo.emit(true);
                }
                if (that.relationType === 'partMeronym') {
                  that.valoreFormMero.emit(0);
                  that.disabilitoMero.emit(true);
                }
              } else {
                if (that.relationType === 'hyponym') {
                  that.valoreFormIpo.emit(1);
                  that.disabilitoIpo.emit(false);
                }
                if (that.relationType === 'partMeronym') {
                  that.valoreFormMero.emit(1);
                  that.disabilitoMero.emit(false);
                }
              }

              if (outgoing.length === 0) {
                if (that.relationType === 'hyponym') {
                  that.valoreFormIpe.emit(0);
                  that.disabilitoIpe.emit(true);
                }
                if (that.relationType === 'partMeronym') {
                  that.valoreFormOlo.emit(0);
                  that.disabilitoOlo.emit(true);
                }
              } else {
                if (that.relationType === 'hyponym') {
                  that.valoreFormIpe.emit(1);
                  that.disabilitoIpe.emit(false);
                }
                if (that.relationType === 'partMeronym') {
                  that.valoreFormOlo.emit(1);
                  that.disabilitoOlo.emit(false);
                }
              }
              subGraph.map(subGraph => {
                let nodi = subGraph.nodes;
                let edges = subGraph.edges;
                edgesInferred = subGraph.edges.map(ele => {
                  return ele.data.inferred
                });
                if (nodi.length > 1000) {
                  alert('attenzioni nodi > 1000, il caricamento dei sensi viene fermato')
                  that.spinner.hideSpinner();
                  // resetto valore a 0 
                  // this.valoreFormIpom.emit(0);
                  // nodi < 1000
                } else {
                  for (var i = 0; i < nodi.length; i++) {
                    // aggiungo nodi
                    that.cy.add([{
                      group: "nodes",
                      data: {
                        id: subGraph.nodes[i].data.id,
                        label: subGraph.nodes[i].data.label
                      }
                    }]);
                    // aggiungo nodi ad array nodi
                    that.arrayNodi.length = that.arrayNodi.push(subGraph.nodes[i].data.id);
                    // salvo gli elementi negli array delle relazioni
                    // alla selezione di un radio button della relazione,
                    // rimuovo elementi delle relazioni che non mi interessano, così rimuovo lo spazio occupato dai nodi nascosti
                    if (that.relationType === 'hyponym') {
                      that.arrayIponimia.length = that.arrayIponimia.push(subGraph.nodes[i].data.id);
                      that.invioArrayIponimia.emit(that.arrayIponimia);
                      sessionStorage.setItem("statoNodiIpo", JSON.stringify(that.arrayIponimia.length));
                      that.invioStatoIpo.emit(that.statoNodiIpo);
                    }
                    if (that.relationType === 'partMeronym') {
                      that.arrayMeronimia.length = that.arrayMeronimia.push(subGraph.nodes[i].data.id);
                      that.invioArrayMeronimia.emit(that.arrayMeronimia);
                      sessionStorage.setItem("statoNodiMero", JSON.stringify(that.arrayMeronimia.length));
                      that.invioStatoMero.emit(that.statoNodiMero);
                    }
                    if (that.relationType === 'synonym') {
                      that.arraySinonimia.length = that.arraySinonimia.push(subGraph.nodes[i].data.id);
                      that.invioArraySinonimia.emit(that.arraySinonimia);
                      sessionStorage.setItem("statoNodiSino", JSON.stringify(that.arraySinonimia.length));
                      that.invioStatoSino.emit(that.statoNodiSino);
                    }

                    that.cy.getElementById(subGraph.nodes[i].data.id).style('display', 'element');
                    that.cy.getElementById(subGraph.nodes[i].data.id).addClass("label");
                    // nascondo nodi secondo livello
                    nodoDBClick.outgoers().targets().successors().targets().style('display', 'none');
                    nodoDBClick.outgoers().targets().incomers().sources().style('display', 'none');
                    nodoDBClick.incomers().sources().predecessors().style('display', 'none');
                    nodoDBClick.style('display', 'element')
                  }

                  for (var i = 0; i < edges.length; i++) {
                    // aggiungo edge
                    that.cy.add([{
                      group: "edges",
                      data: {
                        id: subGraph.edges[i].data.id,
                        source: subGraph.edges[i].data.source,
                        target: subGraph.edges[i].data.target
                      }
                    }]);
                    // aggiungo edge ad array di edges
                    that.arrayEdge.length = that.arrayEdge.push(that.cy.getElementById(subGraph.edges[i].data.id));
                    let edgesRecuperati = that.cy.getElementById(edges[i].data.id);
                    that.cy.batch(function () {
                      edgesRecuperati
                        .removeClass('2livello')
                        .addClass('edges')
                        .style('display', 'element')
                        ;
                    });

                    if (that.relationType === 'hyponym') {
                      sessionStorage.setItem("statoEdgeIpo", JSON.stringify(that.arrayEdge.length));
                    }
                    if (that.relationType === 'partMeronym') {
                      sessionStorage.setItem("statoEdgeMero", JSON.stringify(that.arrayEdge.length));
                    }
                    if (that.relationType === 'synonym') {
                      sessionStorage.setItem("statoEdgeSino", JSON.stringify(that.arrayEdge.length));
                    }

                    that.cy.batch(function () {
                      nodoDBClick
                        .removeClass('2livello')
                        .removeClass('grigio')
                        .addClass('1livello')
                        ;
                    });
                    let nodiConnessi = that.cy.getElementById(edges[i].data.id).connectedNodes();
                    if (edges[i].data.relationType === 'hyponym') {
                      that.cy.batch(function () {
                        nodiConnessi
                          .removeClass('grigio')
                          .removeClass('2livello')
                          .removeClass('meronimia')
                          .removeClass('sinonimia')
                          .removeClass('iponimiaDBClick')
                          .addClass('iponimia')
                          ;
                      })
                      nodoDBClick.addClass('iponimiaDBClick');
                    }
                    if (edges[i].data.relationType === 'partMeronym') {
                      that.cy.batch(function () {
                        nodiConnessi
                          .removeClass('grigio')
                          .removeClass('2livello')
                          .removeClass('iponimia')
                          .removeClass('sinonimia')
                          .removeClass('meronimiaDBClick')
                          .addClass('meronimia')
                          ;
                      })
                      nodoDBClick.addClass('meronimiaDBClick');
                    }
                    // nodi inferiti visibili SOLO nella relazione di sinonimia
                    if (edges[i].data.relationType === 'synonym') {
                      nodoDBClick.outgoers().targets().successors().style('display', 'element');
                      nodoDBClick.incomers().sources().predecessors().style('display', 'element');

                      that.cy.batch(function () {
                        nodiConnessi
                          .removeClass('grigio')
                          .removeClass('2livello')
                          .removeClass('iponimia')
                          .removeClass('meronimia')
                          .removeClass('sinonimiaDBClick')
                          .addClass('sinonimia')
                          ;
                      })
                      nodoDBClick.addClass('sinonimiaDBClick');

                      if (edgesInferred[i] === true) {
                        that.cy.getElementById(subGraph.edges[i].data.id).addClass("inferred");
                      } else {
                        that.cy.getElementById(subGraph.edges[i].data.id).removeClass("inferred");
                        that.cy.getElementById(subGraph.edges[i].data.id).addClass("edges");
                      }
                    }
                    // edge > 499
                    if (edges.length > 499) {
                      let nodiGrigi = that.cy.getElementById(edges[i].data.id).connectedNodes();
                      let edgeGrigi = that.cy.getElementById(edges[i].data.id);
                      //  RIMUOVO TUTTE LE CLASSI DI STILE
                      that.cy.batch(function () {
                        nodiGrigi
                          .removeClass('meronimia')
                          .removeClass('sinonimia')
                          .removeClass('meronimiaDBClick')
                          .removeClass('sinonimiaDBClick')
                          .removeClass('iponimia')
                          .removeClass('iponimiaDBClick')
                          .removeClass('label')
                          .addClass('bigGraph')
                          ;
                      });
                      that.cy.batch(function () {
                        edgeGrigi
                          .removeClass('edges')
                          ;
                      });
                      if (edges[i].data.relationType === 'hyponym') {
                        nodoDBClick.addClass('iponimiaDBClick');
                      }
                      if (edges[i].data.relationType === 'partMeronym') {
                        nodoDBClick.addClass('meronimiaDBClick');
                      }
                      if (edges[i].data.relationType === 'synonym') {
                        nodoDBClick.addClass('sinonimiaDBClick');
                      }
                      nodoDBClick.style('z-index', '1')
                    }
                  }
                  if (that.relationType === 'hyponym' || that.relationType === 'partMeronym') {
                    that.dbClic.posizioni(event);
                    if (nodoDBClick.connectedEdges().toArray().length > 20 && nodoDBClick.connectedEdges().toArray().length < 200) {
                      that.cy.fit();
                    } else if (nodoDBClick.connectedEdges().toArray().length > 200 || nodoDBClick.connectedEdges().toArray().length > 200) {
                      that.cy.fit();
                    } else {
                      that.cy.zoom({
                        level: 1.0, // the zoom level
                      });
                      that.cy.center();
                    }
                    if (that.isGraphOutOfView() === true) {
                      that.cy.fit();
                    }
                  }
                  if (that.relationType === 'synonym') {
                    that.layoutSinonimi = nodoDBClick.outgoers().targets().layout({
                      name: 'circle',
                      padding: 200,
                      avoidOverlap: true,
                      radius: 10,
                      startAngle: 3 / 2 * Math.PI,
                      sweep: undefined,
                      clockwise: true,
                    });
                    that.layoutSinonimi.run();
                  }
                }
              })
            });
          },
          disabled: false
        },
        {
          id: 'chiudiNodo',
          content: 'remove node',
          tooltipText: 'remove node',
          selector: 'node',
          onClickFunction: function (event) {
            // that.ctxMenuOpen = true;
            sessionStorage.setItem('focusNode', event.target.data().id);
            let target = event.target;
            target.style("display", "none");
            // svuoto array nodi selezionati
            that.nodiSelezionati.emit();
            if (that.cy.elements(':visible').toArray().length === 0) {
              // svuoto campo input
              that.formCercaSenso.setValue({ cercaUnSenso: '' });
              sessionStorage.clear();
            }
          },
          disabled: false
        },
        {
          id: 'chiudiNodi',
          content: 'remove nodes',
          tooltipText: 'remove nodes',
          selector: 'node',
          onClickFunction: function (event) {
            // that.ctxMenuOpen = true;
            sessionStorage.setItem('focusNode', event.target.data().id);
            let target = event.target;
            that.cy.remove(that.cy.elements(':visible'));
            target.restore();
            if (that.relationType === 'hyponym') {
              that.arrayIponimia = [];
              that.invioArrayIponimia.emit(that.arrayIponimia);
              sessionStorage.removeItem("statoNodiIpo");
              sessionStorage.removeItem('statoEdgeIpo');
              that.valoreFormIpo.emit(0);
              that.valoreFormIpe.emit(0);
              that.disabilitoIpe.emit(false);
              that.disabilitoIpo.emit(false);
            }
            if (that.relationType === 'partMeronym') {
              that.arrayMeronimia = [];
              that.invioArrayMeronimia.emit(that.arrayMeronimia);
              sessionStorage.removeItem("statoNodiMero");
              sessionStorage.removeItem('statoEdgeMero');
              that.valoreFormMero.emit(0);
              that.valoreFormOlo.emit(0);
              that.disabilitoMero.emit(false);
              that.disabilitoOlo.emit(false);
            }
            if (that.relationType === 'synonym') {
              that.arraySinonimia = [];
              that.invioArraySinonimia.emit(that.arraySinonimia);
              sessionStorage.removeItem("statoNodiSino");
              sessionStorage.removeItem('statoEdgeSino');
            }
            if (that.relationType === 'tutteRelazioni') {
              that.arrayTutteRelazioni = [];
              that.invioArrayTutteRelazioni.emit(that.arrayTutteRelazioni);
              that.valoreFormTutteRelazioni.emit(0);
              sessionStorage.removeItem('statoTutteRelazioni');
              that.cy.remove(that.cy.elements(':visible'));
              target.restore();
            }
            that.cy.center(target);
            that.cy.zoom({
              level: 1.0, // the zoom level
            });
          },
          disabled: false
        },
        {
          id: 'chiudiNodiEntranti',
          content: 'remove incoming nodes',
          tooltipText: 'remove incoming nodes',
          selector: 'node',
          onClickFunction: function (event) {
            sessionStorage.setItem('focusNode', event.target.data().id);
            let target = event.target;
            that.cy.remove(target.predecessors());
            that.cy.remove(target.predecessors().sources());
            target.restore();
            if (that.relationType === 'hyponym') {
              that.valoreFormIpo.emit(0);
              that.disabilitoIpo.emit(false);
            }
            if (that.relationType === 'partMeronym') {
              that.valoreFormMero.emit(0);
              that.disabilitoMero.emit(false);
            }
            that.cy.center(target);
            that.cy.zoom({
              level: 1.0, // the zoom level
            });
          },
          disabled: false
        },
        {
          id: 'chiudiNodiUscenti',
          content: 'remove outgoing nodes',
          tooltipText: 'remove outgoing nodes',
          selector: 'node',
          onClickFunction: function (event) {
            sessionStorage.setItem('focusNode', event.target.data().id);
            let target = event.target;
            that.cy.remove(target.successors());
            that.cy.remove(target.successors().targets());

            target.restore();
            if (that.relationType === 'hyponym') {
              that.valoreFormIpe.emit(0);
              that.disabilitoIpe.emit(false);
            }
            if (that.relationType === 'partMeronym') {
              that.valoreFormOlo.emit(0);
              that.disabilitoOlo.emit(false);
            }
          },
          disabled: false
        },
        {
          id: 'spiegazione',
          content: 'spiegazione',
          tooltipText: 'spiegazione',
          selector: 'edge.inferred',
          onClickFunction: function (event) {
          },
          disabled: false
        },
      ],
    };
    this.contextMenu.emit(this.cy.contextMenus(this.ctxMenu));
  }

  isGraphOutOfView() {
    const width = this.cy.width();
    const height = this.cy.height();
    const rbb = this.cy.elements().renderedBoundingbox();

    return rbb.x1 < 0 || rbb.y1 < 0 || rbb.x2 > width || rbb.y2 > height;
  }
}
